// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Manage Nodes ────────────────────────────────────────────────────
   Visual language borrowed from the View Notes / Medical Notes dialog
   (view-notes.scss): teal accent, soft panel cards, compact uppercase
   section heads. Plain CSS (no @extend / nesting) so it is loader-safe.
   ──────────────────────────────────────────────────────────────────── */
/* Shared Admin Component Styles */
/* Shared Design Variables for Admin Components */
:root {
  --primary-color: #7d48b0;
  --primary-light: #a78bc2;
  --primary-gradient: linear-gradient(135deg, #7d48b0 0%, #a78bc2 100%);
  --surface-white: #ffffff;
  --surface-gray-50: #fafbfc;
  --surface-gray-100: #f4f6f8;
  --surface-gray-200: #e8ecf0;
  --text-primary: #1a1d29;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --border-light: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  --radius-2xl: 20px;
}
/* Common Container Styles */
.admin-container {
  width: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}
/* Modern Card Design */
.admin-card {
  background: var(--surface-white);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  -webkit-box-shadow: var(--shadow-lg);
          box-shadow: var(--shadow-lg);
  backdrop-filter: blur(10px);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}
.admin-card .ant-card-body {
  padding: 0;
}
/* Page Header with Title and Filters */
.admin-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-bottom: 1rem;
  padding: 0.25rem 0rem;
  gap: 2rem;
}
.admin-page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.025em;
  text-transform: uppercase;
  white-space: nowrap;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}
/* Inline Filter Section */
.admin-filters-inline {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 1rem;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.admin-filters-inline .ant-input-affix-wrapper,
.admin-filters-inline .ant-select-selector {
  border: 1px solid #d1d5db;
  border-radius: var(--radius-md);
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  height: 40px;
}
.admin-filters-inline .ant-select-selection-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::-webkit-input-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::-moz-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input:-ms-input-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::-ms-input-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input-affix-wrapper:hover,
.admin-filters-inline .ant-select-selector:hover {
  border-color: var(--primary-light);
  -webkit-box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);
          box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);
}
.admin-filters-inline .ant-input-affix-wrapper:focus-within,
.admin-filters-inline .ant-select-focused .ant-select-selector {
  border-color: var(--primary-color);
  -webkit-box-shadow: 0 0 0 3px rgb(239 130 0 / 0.15);
          box-shadow: 0 0 0 3px rgb(239 130 0 / 0.15);
}
.admin-filters-inline .ant-btn {
  height: 40px;
  border: 1px solid #d1d5db;
  border-radius: var(--radius-md);
  font-weight: 500;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
}
.admin-filters-inline .ant-btn:hover {
  -webkit-box-shadow: var(--shadow-md);
          box-shadow: var(--shadow-md);
}
/* Enhanced Table Design */
.admin-table {
  border-radius: 0;
  overflow: hidden;
  -webkit-box-shadow: none;
          box-shadow: none;
}
/* .admin-table .ant-table-thead > tr > th {
  padding: 12px 16px !important;
  border-bottom: 2px solid var(--border-light);
  font-weight: 700;
  font-size: 0.875rem;
  color: var(--text-primary);
  text-transform: uppercase;
  letter-spacing: 0.025em;
  position: sticky;
  top: 0;
  z-index: 10;
} */
.admin-table .ant-table-tbody > tr {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.admin-table .ant-table-tbody > tr:hover {
  background: linear-gradient(135deg, var(--surface-gray-50) 0%, var(--surface-white) 100%);
}
.admin-table .ant-table-tbody > tr > td {
  padding: 10px 16px !important;
  border-bottom: 1px solid var(--border-light);
  font-weight: 500;
  color: var(--text-primary);
}
/* Modern Action Buttons */
.action-buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 6px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.action-buttons .ant-btn {
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-weight: 600;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border: none;
  height: 36px;
  padding: 0 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.action-buttons .ant-btn:hover {
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
}
/* Enhanced Status Badges */
.status-active {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 2px 8px;
  background: rgb(218,243, 238);
  color: rgb(0, 121,92) !important;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.status-inactive {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 2px 8px;
  background: #c8bbbb;
  color: #e44f4f;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
}
/* Modern Error Container */
.error-container {
  margin: 1rem auto;
  padding: 1.5rem;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: var(--radius-lg);
  color: var(--danger-color);
  -webkit-box-shadow: var(--shadow-md);
          box-shadow: var(--shadow-md);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  font-weight: 500;
}
.retry-button {
  background: var(--danger-color);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  padding: 8px 16px;
  font-weight: 500;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.retry-button:hover {
  -webkit-box-shadow: var(--shadow-md);
          box-shadow: var(--shadow-md);
}
/* Pagination Styling */
.admin-table .ant-pagination {
  margin: 2rem 0 1rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.admin-table .ant-pagination .ant-pagination-item {
  border-radius: var(--radius-md);
  border: 1px solid var(--border-light);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.admin-table .ant-pagination .ant-pagination-item:hover {
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
}
.admin-table .ant-pagination .ant-pagination-item-active {
  background: var(--primary-gradient);
  border-color: var(--primary-color);
}
.admin-table .ant-pagination .ant-pagination-item-active a {
  color: white;
  font-weight: 600;
}
/* Enhanced Responsive Design */
@media (max-width: 1400px) {
  .admin-header {
    gap: 1rem;
  }

  .admin-filters-inline {
    gap: 0.5rem;
  }

  .admin-filters-inline .ant-input-affix-wrapper {
    width: 250px;
  }

  .admin-filters-inline .ant-select {
    width: 140px;
  }
}
@media (max-width: 1200px) {
  .admin-header {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 1.5rem;
  }

  .admin-header .page-title {
    -ms-flex-item-align: center;
        align-self: center;
  }

  .admin-filters-inline {
    width: 100%;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }
}
@media (max-width: 768px) {
  .admin-header {
    padding: 1rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    text-align: center;
    gap: 1rem;
  }

  .admin-header .page-title {
    font-size: 1.5rem;
  }

  .admin-filters-inline {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    width: 100%;
    gap: 0.75rem;
  }

  .admin-filters-inline .ant-input-affix-wrapper,
  .admin-filters-inline .ant-select-selector,
  .admin-filters-inline .ant-btn {
    width: 100%;
  }

  .action-buttons {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 4px;
  }

  .action-buttons .ant-btn {
    width: 100%;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .admin-table .ant-table-thead > tr > th,
  .admin-table .ant-table-tbody > tr > td {
    padding: 12px 8px !important;
  }
}
@media (max-width: 480px) {
  .admin-header .page-title {
    font-size: 1.5rem;
  }

  .admin-header {
    padding: 0.75rem;
  }

  .admin-card {
    margin: 0.5rem auto;
    border-radius: var(--radius-md);
  }
}
:root {
  --mn-border: #e3e6eb;
  --mn-muted: #6b7280;
  --mn-strong: #1f2937;
  --mn-accent: #0f766e;        /* teal-700 */
  --mn-accent-dark: #0b5b54;
  --mn-accent-soft: #ccfbf1;   /* teal-100 */
  --mn-head-bg: #f3f5f8;
  --mn-row-hover: #f4faf9;     /* teal-tinted hover */
}
.nodes-list { width: 100%; }
/* ── Page shell ──────────────────────────────────────────────────── */
.mn-page {
  width: 100%;
  padding: 16px;
  font-size: 13px;
  color: var(--mn-strong);
}
/* ── Panel card (shared by list + forms) ─────────────────────────── */
.mn-panel {
  background: #fff;
  border: 1px solid var(--mn-border);
  border-radius: 10px;
  -webkit-box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 14px rgba(15, 23, 42, 0.05);
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 14px rgba(15, 23, 42, 0.05);
  overflow: hidden;
}
.mn-form-panel {
  max-width: 760px;
  margin: 0 auto;
}
/* ── Panel head ──────────────────────────────────────────────────── */
.mn-panel-head {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  padding: 10px 16px;
  background: var(--mn-head-bg);
  border-bottom: 1px solid var(--mn-border);
}
.mn-panel-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #334155;
}
.mn-panel-title::before {
  content: '';
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: var(--mn-accent);
}
.mn-count {
  font-size: 0.66rem;
  font-weight: 700;
  color: #fff;
  background: var(--mn-accent);
  border-radius: 10px;
  padding: 1px 8px;
  line-height: 16px;
  letter-spacing: 0;
}
/* ── Filters in the head ─────────────────────────────────────────── */
.mn-filters {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.mn-filters .ant-input-affix-wrapper,
.mn-filters .ant-select .ant-select-selector {
  height: 34px;
  border-radius: 8px;
  border: 1px solid #d7dbe2;
}
.mn-filters .ant-input-affix-wrapper:hover,
.mn-filters .ant-select:hover .ant-select-selector {
  border-color: var(--mn-accent);
}
.mn-filters .ant-input-affix-wrapper-focused,
.mn-filters .ant-select-focused .ant-select-selector {
  border-color: var(--mn-accent) !important;
  -webkit-box-shadow: 0 0 0 2px rgba(15, 118, 110, 0.12) !important;
          box-shadow: 0 0 0 2px rgba(15, 118, 110, 0.12) !important;
}
.mn-filters .ant-btn {
  height: 34px;
  border-radius: 8px;
}
/* ── Panel body ──────────────────────────────────────────────────── */
.mn-panel-body { padding: 8px; }
.mn-form-panel .mn-panel-body { padding: 20px 22px; }
/* ── Table ───────────────────────────────────────────────────────── */
.mn-table .ant-table {
  font-size: 0.8rem;
  background: transparent;
}
.mn-table .ant-table-thead > tr > th {
  background: var(--mn-head-bg) !important;
  color: #475569 !important;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 9px 12px !important;
  border-bottom: 1px solid var(--mn-border) !important;
}
.mn-table .ant-table-thead > tr > th::before { display: none !important; }
.mn-table .ant-table-tbody > tr > td {
  padding: 8px 12px !important;
  border-bottom: 1px solid #eef1f4 !important;
  color: var(--mn-strong);
}
.mn-table .ant-table-tbody > tr:hover > td {
  background: var(--mn-row-hover) !important;
}
/* cell decorations */
.mn-sno { color: var(--mn-muted); font-weight: 600; }
.mn-name { font-weight: 600; color: var(--mn-strong); }
.mn-mono { font-family: 'SFMono-Regular', Menlo, Consolas, monospace; font-size: 0.78rem; }
.mn-aet {
  display: inline-block;
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--mn-accent);
  background: var(--mn-accent-soft);
  border-radius: 4px;
  padding: 1px 6px;
}
.mn-loc {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #475569;
  background: #eef1f5;
  border-radius: 4px;
  padding: 1px 6px;
}
.mn-dim { color: #aab1bb; }
/* ── Edit / Delete icon buttons ──────────────────────────────────── */
.mn-icon-btn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 7px;
  border: 1px solid var(--mn-border);
  background: #fff;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
}
.mn-icon-btn.mn-edit { color: var(--mn-accent); }
.mn-icon-btn.mn-edit:hover {
  color: #fff;
  background: var(--mn-accent);
  border-color: var(--mn-accent);
}
.mn-icon-btn.mn-delete { color: #dc2626; }
.mn-icon-btn.mn-delete:hover {
  color: #fff;
  background: #dc2626;
  border-color: #dc2626;
}
/* ── Forms (add + edit) ──────────────────────────────────────────── */
.mn-form .ant-form-item { margin-bottom: 14px; }
.mn-form .ant-form-item-label > label {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #475569;
}
.mn-form .ant-input,
.mn-form .ant-input-number,
.mn-form .ant-select .ant-select-selector,
.mn-form textarea.ant-input {
  border-radius: 8px;
  border-color: #d7dbe2;
}
.mn-form .ant-input:hover,
.mn-form .ant-select:hover .ant-select-selector,
.mn-form .ant-input:focus,
.mn-form .ant-input-focused {
  border-color: var(--mn-accent);
}
.mn-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 18px;
}
.mn-form-grid .mn-span-2 { grid-column: 1 / -1; }
.mn-form-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
  padding-top: 14px;
  border-top: 1px dashed var(--mn-border);
}
/* teal primary button */
.mn-primary-btn.ant-btn-primary,
.mn-edit-modal .ant-btn-primary {
  background: var(--mn-accent) !important;
  border-color: var(--mn-accent) !important;
  border-radius: 8px;
  font-weight: 600;
}
.mn-primary-btn.ant-btn-primary:hover,
.mn-edit-modal .ant-btn-primary:hover {
  background: var(--mn-accent-dark) !important;
  border-color: var(--mn-accent-dark) !important;
}
/* ── Edit modal ──────────────────────────────────────────────────── */
.mn-edit-modal .ant-modal-content { border-radius: 12px; overflow: hidden; padding: 0; }
.mn-edit-modal .ant-modal-header {
  margin: 0;
  padding: 14px 20px;
  background: var(--mn-head-bg);
  border-bottom: 1px solid var(--mn-border);
}
.mn-edit-modal .ant-modal-title {
  font-size: 0.86rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #334155;
}
.mn-edit-modal .ant-modal-body { padding: 20px 22px; }
.mn-edit-modal .ant-modal-footer { margin: 0; padding: 12px 20px; border-top: 1px solid var(--mn-border); }
.mn-edit-modal .ant-modal-close { top: 10px; }
/* ── Responsive ──────────────────────────────────────────────────── */
@media (max-width: 720px) {
  .mn-form-grid { grid-template-columns: 1fr; }
  .mn-filters { width: 100%; }
  .mn-filters .ant-input-affix-wrapper { -webkit-box-flex: 1; -ms-flex: 1 1 100%; flex: 1 1 100%; }
}
`, "",{"version":3,"sources":["webpack://./pages/ManageNodes/manage-nodes.css","webpack://./styles/admin-components.css","webpack://./styles/admin-variables.css"],"names":[],"mappings":"AAAA;;;;yEAIyE;ACJzE,kCAAkC;ACAlC,iDAAiD;AACjD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,qEAAqE;EACrE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;EAC/E,gFAAgF;EAChF,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;ADtBA,4BAA4B;AAC5B;EACE,WAAW;EACX,6DAA6D;AAC/D;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,oCAA4B;UAA5B,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAyB;EAAzB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AAEA;EACE,UAAU;AACZ;AAEA,uCAAuC;AACvC;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAc;MAAd,cAAc;AAChB;AAEA,0BAA0B;AAC1B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,oCAA4B;UAA5B,4BAA4B;EAC5B,iCAAyB;EAAzB,yBAAyB;EACzB,YAAY;AACd;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAEA;;EAEE,kCAAkC;EAClC,kDAA0C;UAA1C,0CAA0C;AAC5C;AAEA;;EAEE,kCAAkC;EAClC,mDAA2C;UAA3C,2CAA2C;AAC7C;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAyB;EAAzB,yBAAyB;EACzB,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAgB;UAAhB,gBAAgB;AAClB;AAEA;;;;;;;;;;;GAWG;AAEH;EACE,iCAAyB;EAAzB,yBAAyB;AAC3B;AAEA;EACE,yFAAyF;AAC3F;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,gBAAgB;EAChB,0BAA0B;AAC5B;AAEA,0BAA0B;AAC1B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iCAAyB;EAAzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA,2BAA2B;AAC3B;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,eAAe;EACf,6DAA6D;EAC7D,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,gBAAgB;AAClB;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,iCAAyB;EAAzB,yBAAyB;AAC3B;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAyB;EAAzB,yBAAyB;AAC3B;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AAEA,+BAA+B;AAC/B;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,2BAAkB;QAAlB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,mBAAe;QAAf,eAAe;EACjB;AACF;AAEA;EACE;IACE,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;AACF;ADtUA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB,SAAS,aAAa;EAC1C,yBAAyB;EACzB,yBAAyB,IAAI,aAAa;EAC1C,qBAAqB;EACrB,uBAAuB,MAAM,sBAAsB;AACrD;AAEA,cAAc,WAAW,EAAE;AAE3B,uEAAuE;AACvE;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,uFAA+E;UAA/E,+EAA+E;EAC/E,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AAEA,uEAAuE;AACvE;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;AAC3C;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AAEA,uEAAuE;AACvE;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA;;EAEE,8BAA8B;AAChC;AAEA;;EAEE,yCAAyC;EACzC,iEAAyD;UAAzD,yDAAyD;AAC3D;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AAEA,uEAAuE;AACvE,iBAAiB,YAAY,EAAE;AAC/B,gCAAgC,kBAAkB,EAAE;AAEpD,uEAAuE;AACvE;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,oDAAoD;AACtD;AAEA,+CAA+C,wBAAwB,EAAE;AAEzE;EACE,4BAA4B;EAC5B,2CAA2C;EAC3C,uBAAuB;AACzB;AAEA;EACE,0CAA0C;AAC5C;AAEA,qBAAqB;AACrB,UAAU,sBAAsB,EAAE,gBAAgB,EAAE;AACpD,WAAW,gBAAgB,EAAE,uBAAuB,EAAE;AACtD,WAAW,yDAAyD,EAAE,kBAAkB,EAAE;AAE1F;EACE,qBAAqB;EACrB,yDAAyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA,UAAU,cAAc,EAAE;AAE1B,uEAAuE;AACvE;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,kCAA0B;EAA1B,0BAA0B;AAC5B;AAEA,uBAAuB,uBAAuB,EAAE;AAChD;EACE,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;AAChC;AAEA,yBAAyB,cAAc,EAAE;AACzC;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AAEA,uEAAuE;AACvE,0BAA0B,mBAAmB,EAAE;AAE/C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AAEA;;;;EAIE,kBAAkB;EAClB,qBAAqB;AACvB;AAEA;;;;EAIE,8BAA8B;AAChC;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AAEA,2BAA2B,mBAAmB,EAAE;AAEhD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;AAEA,wBAAwB;AACxB;;EAEE,uCAAuC;EACvC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;;EAEE,4CAA4C;EAC5C,8CAA8C;AAChD;AAEA,uEAAuE;AACvE,oCAAoC,mBAAmB,EAAE,gBAAgB,EAAE,UAAU,EAAE;AAEvF;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;AAC3C;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AAEA,iCAAiC,kBAAkB,EAAE;AACrD,mCAAmC,SAAS,EAAE,kBAAkB,EAAE,sCAAsC,EAAE;AAC1G,kCAAkC,SAAS,EAAE;AAE7C,uEAAuE;AACvE;EACE,gBAAgB,0BAA0B,EAAE;EAC5C,cAAc,WAAW,EAAE;EAC3B,uCAAuC,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE;AACzD","sourcesContent":["/* ── Manage Nodes ────────────────────────────────────────────────────\r\n   Visual language borrowed from the View Notes / Medical Notes dialog\r\n   (view-notes.scss): teal accent, soft panel cards, compact uppercase\r\n   section heads. Plain CSS (no @extend / nesting) so it is loader-safe.\r\n   ──────────────────────────────────────────────────────────────────── */\r\n@import '../../styles/admin-components.css';\r\n\r\n:root {\r\n  --mn-border: #e3e6eb;\r\n  --mn-muted: #6b7280;\r\n  --mn-strong: #1f2937;\r\n  --mn-accent: #0f766e;        /* teal-700 */\r\n  --mn-accent-dark: #0b5b54;\r\n  --mn-accent-soft: #ccfbf1;   /* teal-100 */\r\n  --mn-head-bg: #f3f5f8;\r\n  --mn-row-hover: #f4faf9;     /* teal-tinted hover */\r\n}\r\n\r\n.nodes-list { width: 100%; }\r\n\r\n/* ── Page shell ──────────────────────────────────────────────────── */\r\n.mn-page {\r\n  width: 100%;\r\n  padding: 16px;\r\n  font-size: 13px;\r\n  color: var(--mn-strong);\r\n}\r\n\r\n/* ── Panel card (shared by list + forms) ─────────────────────────── */\r\n.mn-panel {\r\n  background: #fff;\r\n  border: 1px solid var(--mn-border);\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 14px rgba(15, 23, 42, 0.05);\r\n  overflow: hidden;\r\n}\r\n\r\n.mn-form-panel {\r\n  max-width: 760px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* ── Panel head ──────────────────────────────────────────────────── */\r\n.mn-panel-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  padding: 10px 16px;\r\n  background: var(--mn-head-bg);\r\n  border-bottom: 1px solid var(--mn-border);\r\n}\r\n\r\n.mn-panel-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 0.82rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: #334155;\r\n}\r\n\r\n.mn-panel-title::before {\r\n  content: '';\r\n  width: 4px;\r\n  height: 16px;\r\n  border-radius: 2px;\r\n  background: var(--mn-accent);\r\n}\r\n\r\n.mn-count {\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  background: var(--mn-accent);\r\n  border-radius: 10px;\r\n  padding: 1px 8px;\r\n  line-height: 16px;\r\n  letter-spacing: 0;\r\n}\r\n\r\n/* ── Filters in the head ─────────────────────────────────────────── */\r\n.mn-filters {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.mn-filters .ant-input-affix-wrapper,\r\n.mn-filters .ant-select .ant-select-selector {\r\n  height: 34px;\r\n  border-radius: 8px;\r\n  border: 1px solid #d7dbe2;\r\n}\r\n\r\n.mn-filters .ant-input-affix-wrapper:hover,\r\n.mn-filters .ant-select:hover .ant-select-selector {\r\n  border-color: var(--mn-accent);\r\n}\r\n\r\n.mn-filters .ant-input-affix-wrapper-focused,\r\n.mn-filters .ant-select-focused .ant-select-selector {\r\n  border-color: var(--mn-accent) !important;\r\n  box-shadow: 0 0 0 2px rgba(15, 118, 110, 0.12) !important;\r\n}\r\n\r\n.mn-filters .ant-btn {\r\n  height: 34px;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* ── Panel body ──────────────────────────────────────────────────── */\r\n.mn-panel-body { padding: 8px; }\r\n.mn-form-panel .mn-panel-body { padding: 20px 22px; }\r\n\r\n/* ── Table ───────────────────────────────────────────────────────── */\r\n.mn-table .ant-table {\r\n  font-size: 0.8rem;\r\n  background: transparent;\r\n}\r\n\r\n.mn-table .ant-table-thead > tr > th {\r\n  background: var(--mn-head-bg) !important;\r\n  color: #475569 !important;\r\n  font-size: 0.7rem !important;\r\n  font-weight: 700 !important;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  padding: 9px 12px !important;\r\n  border-bottom: 1px solid var(--mn-border) !important;\r\n}\r\n\r\n.mn-table .ant-table-thead > tr > th::before { display: none !important; }\r\n\r\n.mn-table .ant-table-tbody > tr > td {\r\n  padding: 8px 12px !important;\r\n  border-bottom: 1px solid #eef1f4 !important;\r\n  color: var(--mn-strong);\r\n}\r\n\r\n.mn-table .ant-table-tbody > tr:hover > td {\r\n  background: var(--mn-row-hover) !important;\r\n}\r\n\r\n/* cell decorations */\r\n.mn-sno { color: var(--mn-muted); font-weight: 600; }\r\n.mn-name { font-weight: 600; color: var(--mn-strong); }\r\n.mn-mono { font-family: 'SFMono-Regular', Menlo, Consolas, monospace; font-size: 0.78rem; }\r\n\r\n.mn-aet {\r\n  display: inline-block;\r\n  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n  color: var(--mn-accent);\r\n  background: var(--mn-accent-soft);\r\n  border-radius: 4px;\r\n  padding: 1px 6px;\r\n}\r\n\r\n.mn-loc {\r\n  display: inline-block;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n  color: #475569;\r\n  background: #eef1f5;\r\n  border-radius: 4px;\r\n  padding: 1px 6px;\r\n}\r\n\r\n.mn-dim { color: #aab1bb; }\r\n\r\n/* ── Edit / Delete icon buttons ──────────────────────────────────── */\r\n.mn-icon-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--mn-border);\r\n  background: #fff;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.mn-icon-btn.mn-edit { color: var(--mn-accent); }\r\n.mn-icon-btn.mn-edit:hover {\r\n  color: #fff;\r\n  background: var(--mn-accent);\r\n  border-color: var(--mn-accent);\r\n}\r\n\r\n.mn-icon-btn.mn-delete { color: #dc2626; }\r\n.mn-icon-btn.mn-delete:hover {\r\n  color: #fff;\r\n  background: #dc2626;\r\n  border-color: #dc2626;\r\n}\r\n\r\n/* ── Forms (add + edit) ──────────────────────────────────────────── */\r\n.mn-form .ant-form-item { margin-bottom: 14px; }\r\n\r\n.mn-form .ant-form-item-label > label {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: #475569;\r\n}\r\n\r\n.mn-form .ant-input,\r\n.mn-form .ant-input-number,\r\n.mn-form .ant-select .ant-select-selector,\r\n.mn-form textarea.ant-input {\r\n  border-radius: 8px;\r\n  border-color: #d7dbe2;\r\n}\r\n\r\n.mn-form .ant-input:hover,\r\n.mn-form .ant-select:hover .ant-select-selector,\r\n.mn-form .ant-input:focus,\r\n.mn-form .ant-input-focused {\r\n  border-color: var(--mn-accent);\r\n}\r\n\r\n.mn-form-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0 18px;\r\n}\r\n\r\n.mn-form-grid .mn-span-2 { grid-column: 1 / -1; }\r\n\r\n.mn-form-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  margin-top: 6px;\r\n  padding-top: 14px;\r\n  border-top: 1px dashed var(--mn-border);\r\n}\r\n\r\n/* teal primary button */\r\n.mn-primary-btn.ant-btn-primary,\r\n.mn-edit-modal .ant-btn-primary {\r\n  background: var(--mn-accent) !important;\r\n  border-color: var(--mn-accent) !important;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n}\r\n\r\n.mn-primary-btn.ant-btn-primary:hover,\r\n.mn-edit-modal .ant-btn-primary:hover {\r\n  background: var(--mn-accent-dark) !important;\r\n  border-color: var(--mn-accent-dark) !important;\r\n}\r\n\r\n/* ── Edit modal ──────────────────────────────────────────────────── */\r\n.mn-edit-modal .ant-modal-content { border-radius: 12px; overflow: hidden; padding: 0; }\r\n\r\n.mn-edit-modal .ant-modal-header {\r\n  margin: 0;\r\n  padding: 14px 20px;\r\n  background: var(--mn-head-bg);\r\n  border-bottom: 1px solid var(--mn-border);\r\n}\r\n\r\n.mn-edit-modal .ant-modal-title {\r\n  font-size: 0.86rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: #334155;\r\n}\r\n\r\n.mn-edit-modal .ant-modal-body { padding: 20px 22px; }\r\n.mn-edit-modal .ant-modal-footer { margin: 0; padding: 12px 20px; border-top: 1px solid var(--mn-border); }\r\n.mn-edit-modal .ant-modal-close { top: 10px; }\r\n\r\n/* ── Responsive ──────────────────────────────────────────────────── */\r\n@media (max-width: 720px) {\r\n  .mn-form-grid { grid-template-columns: 1fr; }\r\n  .mn-filters { width: 100%; }\r\n  .mn-filters .ant-input-affix-wrapper { flex: 1 1 100%; }\r\n}\r\n","/* Shared Admin Component Styles */\r\n@import './admin-variables.css';\r\n\r\n/* Common Container Styles */\r\n.admin-container {\r\n  width: 100%;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\r\n}\r\n\r\n/* Modern Card Design */\r\n.admin-card {\r\n  background: var(--surface-white);\r\n  border: 1px solid var(--border-light);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-lg);\r\n  backdrop-filter: blur(10px);\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.admin-card .ant-card-body {\r\n  padding: 0;\r\n}\r\n\r\n/* Page Header with Title and Filters */\r\n.admin-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  padding: 0.25rem 0rem;\r\n  gap: 2rem;\r\n}\r\n\r\n.admin-page-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n  letter-spacing: -0.025em;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Inline Filter Section */\r\n.admin-filters-inline {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.admin-filters-inline .ant-input-affix-wrapper,\r\n.admin-filters-inline .ant-select-selector {\r\n  border: 1px solid #d1d5db;\r\n  border-radius: var(--radius-md);\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all 0.2s ease;\r\n  height: 40px;\r\n}\r\n\r\n.admin-filters-inline .ant-select-selection-placeholder {\r\n  color: #9ca3af !important;\r\n  font-style: italic;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.admin-filters-inline .ant-input::placeholder {\r\n  color: #9ca3af !important;\r\n  font-style: italic;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.admin-filters-inline .ant-input-affix-wrapper:hover,\r\n.admin-filters-inline .ant-select-selector:hover {\r\n  border-color: var(--primary-light);\r\n  box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);\r\n}\r\n\r\n.admin-filters-inline .ant-input-affix-wrapper:focus-within,\r\n.admin-filters-inline .ant-select-focused .ant-select-selector {\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 3px rgb(239 130 0 / 0.15);\r\n}\r\n\r\n.admin-filters-inline .ant-btn {\r\n  height: 40px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: var(--radius-md);\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.admin-filters-inline .ant-btn:hover {\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n/* Enhanced Table Design */\r\n.admin-table {\r\n  border-radius: 0;\r\n  overflow: hidden;\r\n  box-shadow: none;\r\n}\r\n\r\n/* .admin-table .ant-table-thead > tr > th {\r\n  padding: 12px 16px !important;\r\n  border-bottom: 2px solid var(--border-light);\r\n  font-weight: 700;\r\n  font-size: 0.875rem;\r\n  color: var(--text-primary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.025em;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n} */\r\n\r\n.admin-table .ant-table-tbody > tr {\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.admin-table .ant-table-tbody > tr:hover {\r\n  background: linear-gradient(135deg, var(--surface-gray-50) 0%, var(--surface-white) 100%);\r\n}\r\n\r\n.admin-table .ant-table-tbody > tr > td {\r\n  padding: 10px 16px !important;\r\n  border-bottom: 1px solid var(--border-light);\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Modern Action Buttons */\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.action-buttons .ant-btn {\r\n  border-radius: var(--radius-md);\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  border: none;\r\n  height: 36px;\r\n  padding: 0 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.action-buttons .ant-btn:hover {\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n/* Enhanced Status Badges */\r\n.status-active {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 8px;\r\n  background: rgb(218,243, 238);\r\n  color: rgb(0, 121,92) !important;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.status-inactive {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 8px;\r\n  background: #c8bbbb;\r\n  color: #e44f4f;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* Modern Error Container */\r\n.error-container {\r\n  margin: 1rem auto;\r\n  padding: 1.5rem;\r\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\r\n  border: 1px solid #fecaca;\r\n  border-radius: var(--radius-lg);\r\n  color: var(--danger-color);\r\n  box-shadow: var(--shadow-md);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-weight: 500;\r\n}\r\n\r\n.retry-button {\r\n  background: var(--danger-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  padding: 8px 16px;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.retry-button:hover {\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n/* Pagination Styling */\r\n.admin-table .ant-pagination {\r\n  margin: 2rem 0 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item {\r\n  border-radius: var(--radius-md);\r\n  border: 1px solid var(--border-light);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item:hover {\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item-active {\r\n  background: var(--primary-gradient);\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item-active a {\r\n  color: white;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Enhanced Responsive Design */\r\n@media (max-width: 1400px) {\r\n  .admin-header {\r\n    gap: 1rem;\r\n  }\r\n\r\n  .admin-filters-inline {\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .admin-filters-inline .ant-input-affix-wrapper {\r\n    width: 250px;\r\n  }\r\n\r\n  .admin-filters-inline .ant-select {\r\n    width: 140px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .admin-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .admin-header .page-title {\r\n    align-self: center;\r\n  }\r\n\r\n  .admin-filters-inline {\r\n    width: 100%;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .admin-header {\r\n    padding: 1rem;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .admin-header .page-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .admin-filters-inline {\r\n    flex-direction: column;\r\n    width: 100%;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .admin-filters-inline .ant-input-affix-wrapper,\r\n  .admin-filters-inline .ant-select-selector,\r\n  .admin-filters-inline .ant-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .action-buttons {\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n\r\n  .action-buttons .ant-btn {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .admin-table .ant-table-thead > tr > th,\r\n  .admin-table .ant-table-tbody > tr > td {\r\n    padding: 12px 8px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .admin-header .page-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .admin-header {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .admin-card {\r\n    margin: 0.5rem auto;\r\n    border-radius: var(--radius-md);\r\n  }\r\n}\r\n","/* Shared Design Variables for Admin Components */\r\n:root {\r\n  --primary-color: #7d48b0;\r\n  --primary-light: #a78bc2;\r\n  --primary-gradient: linear-gradient(135deg, #7d48b0 0%, #a78bc2 100%);\r\n  --surface-white: #ffffff;\r\n  --surface-gray-50: #fafbfc;\r\n  --surface-gray-100: #f4f6f8;\r\n  --surface-gray-200: #e8ecf0;\r\n  --text-primary: #1a1d29;\r\n  --text-secondary: #6b7280;\r\n  --text-muted: #9ca3af;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --border-light: #e2e8f0;\r\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\r\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\r\n  --radius-sm: 6px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 12px;\r\n  --radius-xl: 16px;\r\n  --radius-2xl: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
